import React from 'react';
import { styled } from '@glitz/react';
import Html from 'Shared/Partials/PropertyTypes/Html';
import { H2, ResponsiveSize } from 'Shared/SharedComponents/atoms/Typography';
import { createGridClasses, createOffsetGridClassLarge } from 'Shared/grid';
import { GridWrap } from 'Shared/PageLayout';

type PropType = {
  heading: string;
  text: Scope.XhtmlString;
};

const SeoContentWrap = styled(GridWrap, {
  margin: {
    top: '80px',
    bottom: '80px'
  },
})

export const SeoContent = ({ heading, text }: PropType) => {  
  return (
    <SeoContentWrap className='grid rows-xs'>
      <div className={createGridClasses(0, 5, createOffsetGridClassLarge(2))}>
        <H2 fontSize={ResponsiveSize.D56_M24}>{heading}</H2>
      </div>
      <div className={createGridClasses(0, 5)}>
        {text && <Html className='editor' html={text.html} />}
      </div>
    </SeoContentWrap>
  );
};
